import React from 'react'

const FooterView =  (props) => (
  <footer className={props.footerClass}>
    <div className="footer-wrap">
        <p className="footer-corporateLink">
          <a className="external" href="https://www.lyzon.co.jp/" target="_blank" rel="noopener noreferrer">LYZONコーポレートサイトへ</a>
        </p>
        <small>©2023 LYZON Inc.</small>
    </div>
  </footer>
)

export default class footerClass extends React.PureComponent {

  render() {
    let footerClassName = (this.props.isModalFooter) ? 'l-footer modal-footer' : 'l-footer'

    return <FooterView footerClass={footerClassName} />
  }
}


// WEBPACK FOOTER //
// ./src/Home/Footer.js